export const getModuleMessages = async (locale: ApplicationLocale) => import(`@/modules/inventory/locales/${locale}.json`);

export default getModuleMessages;
